export type ContactRequest = {
  name: string;
  email: string;
  subject: string;
  message: string;
};

/**
 * Point d'intégration unique du formulaire de contact.
 *
 * Tant que `VITE_CONTACT_ENDPOINT` n'est pas renseigné, la demande n'est
 * transmise nulle part : le formulaire se comporte normalement côté visiteur,
 * mais rien ne quitte le navigateur. Brancher un backend revient à définir la
 * variable d'environnement, aucun autre fichier n'est à toucher.
 */
export async function submitContactRequest(request: ContactRequest): Promise<void> {
  const endpoint = import.meta.env.VITE_CONTACT_ENDPOINT;

  if (!endpoint) {
    if (import.meta.env.DEV) {
      console.warn('VITE_CONTACT_ENDPOINT non défini : la demande n\'est pas transmise.', request);
    }
    return;
  }

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    throw new Error(`Envoi refusé par le serveur (${String(response.status)}).`);
  }
}
